import { useCallback, useRef } from 'react';
import { useRemote } from '../providers/RemoteProvider';
export const useTrackReady = () => {
  const {
    trackReady: trackReadyFromRemoteProvider
  } = useRemote();
  const didReportReady = useRef(false);
  const trackReadyOnce = useCallback(data => {
    if (!didReportReady.current) {
      didReportReady.current = true;
      return trackReadyFromRemoteProvider(data);
    }
    return undefined;
  }, [trackReadyFromRemoteProvider]);
  return {
    trackReadyOnce
  };
};
//# sourceMappingURL=useTrackReady.js.map